<template>
    <gravy-layout v-if="isDashboard">
      <router-view></router-view>
      <loading-spinner v-if="spinnerStatus" />
    </gravy-layout>
    <gravy-login v-else />

</template>

<script>
import GravyLayout from "@/components/GravyLayout";
import GravyLogin from "@/views/GravyLogin";
import LoadingSpinner from "@/components/Functional/Spinners/LoadingSpinner";
export default {
  components: {LoadingSpinner, GravyLogin, GravyLayout},
  computed: {
    isDashboard() {
      return this.$route.name !== 'Login'
    },
    spinnerStatus() {
      return this.$store.getters.getSpinnerStatus
    }
  }
}
</script>

